import "./Testimonials.css";
import borderHorizontal from "../../assets/testimonial-border-horizontal.avif";
import borderVertical from "../../assets/testimonial-border-vertical.avif";
import DemoRequestForm from "../DemoRequestForm/DemoRequestForm";
import { Link } from "react-router-dom";

export default function Testimonials() {
  return (
    <section className="testimonials-section">

      <div className="testimonials-header">
        <h2>
          <img
            src="https://img.icons8.com/?size=100&id=upd5xh7hPe0R&format=png&color=000000"
            alt="Pixel heart"
            className="testimonials-title-icon"
          />
          <span>Attracts love like nobody's business.</span>
        </h2>
        <p>See how ambitious teams use SmushChat to transform customer support.</p>
      </div>
      <div className="am-logos-migrated-wrapper">
        <Link to="/blog/tefl-institute-technical-case-study" className="am-logos-migrated-link has-case-study w-inline-block" aria-label="Read The TEFL Institute case study">
          <div className="case-study-face case-study-front">
            <div className="am-logo-migrated-image-container">
              <img loading="lazy" src="https://www.smushlabs.ai/Clients/The_TEFL_Institute_full.svg" alt="The TEFL Institute" className="am-image" />
            </div>
            <div className="am-logo-migrated-btn-wrapper">
              <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">60,000 support emails avoided</div>
            </div>
            <div className="am-logos-migrated-background"></div>
          </div>
          <div className="case-study-face case-study-back tefl-institute-photo">
            <img loading="lazy" src="/blog-images/tefl-institute-team-customer-story.webp" alt="The TEFL Institute team in 2025" className="case-study-back-photo" />
            <span>Customer story</span><strong>Read The TEFL Institute case study</strong><b>Read case study →</b>
          </div>
        </Link>

        <div className="am-logos-migrated-link has-hover w-inline-block">
          <div className="am-logo-migrated-image-container">
            <img loading="lazy" src="https://www.smushlabs.ai/Clients/TEFL_Ireland_full.svg" alt="TEFL Ireland" className="am-image" />
          </div>
          <div className="am-logo-migrated-btn-wrapper">
            <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">Gets thanked more than humans</div>
          </div>
          <img src={borderVertical} loading="lazy" alt="" className="am-logos-migrated-border-vertical is-reversed" />
          <div className="am-logos-migrated-background"></div>
        </div>

        <Link to="/blog/premier-tefl-case-study" className="am-logos-migrated-link has-case-study w-inline-block" aria-label="Read the Premier TEFL case study">
          <div className="case-study-face case-study-front">
            <div className="am-logo-migrated-image-container">
              <img loading="lazy" src="https://www.smushlabs.ai/Clients/premier_tefl_full.svg" alt="Premier TEFL" className="am-image" />
            </div>
            <div className="am-logo-migrated-btn-wrapper">
              <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">Resolved 12,000 after-hours queries</div>
            </div>
            <img src={borderVertical} loading="lazy" alt="" className="am-logos-migrated-border-vertical is-reversed" />
            <div className="am-logos-migrated-background"></div>
          </div>
          <div className="case-study-face case-study-back premier-tefl-photo">
            <img loading="lazy" src="/blog-images/premier-tefl-team-customer-story.webp" alt="The Premier TEFL team" className="case-study-back-photo" />
            <span>Customer story</span><strong>Read the Premier TEFL case study</strong><b>Read case study →</b>
          </div>
        </Link>

        <div className="am-logos-migrated-link is-right has-hover w-inline-block">
          <div className="am-logo-migrated-image-container">
            <img loading="lazy" src="https://www.smushlabs.ai/Clients/hair_repair_clinic_full.webp" alt="Hair Repair Clinic" className="am-image" />
          </div>
          <div className="am-logo-migrated-btn-wrapper">
            <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">Automated "Where's my order?"</div>
          </div>
          <img src={borderVertical} loading="lazy" alt="" className="am-logos-migrated-border-vertical" />
          <div className="am-logos-migrated-background"></div>
        </div>

        <div className="am-logos-migrated-link is-bottom has-hover w-inline-block">
          <div className="am-logo-migrated-image-container">
            <img loading="lazy" src="https://www.smushlabs.ai/Clients/surgery_group_full.png" alt="Surgery Group" className="am-image" />
          </div>
          <div className="am-logo-migrated-btn-wrapper">
            <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">Cut down repeat queries by 90%</div>
          </div>
          <img src={borderHorizontal} loading="lazy" alt="" className="am-logos-migrated-border-horizontal is-reversed" />
          <img src={borderVertical} loading="lazy" alt="" className="am-logos-migrated-border-vertical is-right" />
          <div className="am-logos-migrated-background is-bottom"></div>
        </div>

        <div className="am-logos-migrated-link is-bottom has-hover w-inline-block">
          <div className="am-logo-migrated-image-container">
            <img loading="lazy" src="https://www.smushlabs.ai/Clients/gepf_full.png" alt="GEPF" className="am-image" />
          </div>
          <div className="am-logo-migrated-btn-wrapper">
            <div className="am-paragraph-14 am-is-half-black-60 am-text-align-center is-logo-migrated">Migrated off Tawk.to</div>
          </div>
          <img src={borderHorizontal} loading="lazy" alt="" className="am-logos-migrated-border-horizontal" />
          <img src={borderVertical} loading="lazy" alt="" className="am-logos-migrated-border-vertical is-right is-reversed" />
          <div className="am-logos-migrated-background is-bottom is-right"></div>
        </div>

        <div className="am-cta-box" id="demo">
          <h3>Request a custom-trained support demo.</h3>
          <p>We can build a limited preview from your public website at no cost. It is not a free plan or trial.</p>
          <DemoRequestForm source="register-interest" buttonText="Register interest" variant="card" />
          <img src={borderHorizontal} loading="lazy" alt="" className="am-logos-migrated-border-horizontal" />
        </div>
      </div>
    </section>
  );
}
